import { jsxs as _, jsx as a } from "react/jsx-runtime";
import { useRef as b, useImperativeHandle as p, useEffect as v, forwardRef as B } from "react";
import { MLPVersion as x } from "./types/enums.js";
import "./components/TextArea/types/enums.js";
import { c as N } from "./bind-6db9bd07.mjs";
import w from "./components/Tooltip/Tooltip.js";
import R from "./components/TextArea/FloatLabelTextArea/FloatLabelTextArea.js";
import { TooltipPreference as y } from "./components/Tooltip/types/enums.js";
import './assets/TextArea.css';const O = "#ffffff", T = "#396e75", G = "#e5fdff", A = "#546223", W = "#f0fae5", $ = "#a65523", E = "#fff1e8", H = "#7f3e3e", Y = "#ffe2e2", F = "#62625a", L = "#f8f8e7", S = "#38539a", j = "#707070", M = "#c8f8d1", q = "#87c9c8", D = "#5291b1", I = "rgba(82, 145, 177, 0.1019607843)", J = "#445685", K = "#181d61", Q = "rgba(24, 29, 97, 0.1019607843)", U = "#5969d6", X = "#ea999d", Z = "#b6577e", P = "rgba(182, 87, 126, 0.1019607843)", aa = "#7e3e80", ea = "#1e247f", ta = "rgba(30, 36, 127, 0.1019607843)", ra = "#da7600", oa = "#107f47", la = "#d91734", ia = "_html_18f0t_75", da = "_textarea_18f0t_284", na = "_icon_18f0t_329", sa = "_disabled_18f0t_380", ca = "_resize_18f0t_387", t = {
  amwayWhite: O,
  darkBlue: T,
  lightBlue: G,
  darkGreen: A,
  lightGreen: W,
  darkOrange: $,
  lightOrange: E,
  darkRed: H,
  lightRed: Y,
  darkYellow: F,
  lightYellow: L,
  darkPurple: S,
  darkGrayOnWhite: j,
  dataVizColor1: M,
  dataVizColor2: q,
  dataVizColor3: D,
  dataVizColor3Background: I,
  dataVizColor4: J,
  dataVizColor5: K,
  dataVizColor5Background: Q,
  dataVizColor6: U,
  dataVizColor7: X,
  dataVizColor8: Z,
  dataVizColor8Background: P,
  dataVizColor9: aa,
  dataVizColor10: ea,
  dataVizColor10Background: ta,
  dataVizAlertOrange: ra,
  dataVizSuccessGreen: oa,
  dataVizWarningRed: la,
  "no-visible": "_no-visible_18f0t_34",
  html: ia,
  textarea: da,
  "textarea-label": "_textarea-label_18f0t_284",
  "textarea-message": "_textarea-message_18f0t_285",
  "textarea-label-tooltip": "_textarea-label-tooltip_18f0t_315",
  "textarea-label-info": "_textarea-label-info_18f0t_321",
  "textarea-validated-valid": "_textarea-validated-valid_18f0t_325",
  "textarea-drawer": "_textarea-drawer_18f0t_325",
  icon: na,
  "textarea-field-container": "_textarea-field-container_18f0t_335",
  "textarea-validated-invalid": "_textarea-validated-invalid_18f0t_338",
  "textarea-field": "_textarea-field_18f0t_335",
  disabled: sa,
  resize: ca,
  "read-only": "_read-only_18f0t_391"
}, m = N.bind(t), g = ({
  id: r = "",
  className: o = "",
  label: e = "",
  labelInfo: n = "",
  status: z,
  disabled: s = !1,
  readOnly: c = !1,
  resize: C = !0,
  required: V = !1,
  message: f = "",
  forwardedRef: h,
  ...l
}) => {
  const d = b();
  p(h, () => d.current), v(() => {
    const i = d.current;
    i.scrollHeight > i.clientHeight && (i.style.height = `${i.scrollHeight}px`);
  }, [l == null ? void 0 : l.value]);
  const u = m("textarea", { [`textarea-validated-${z}`]: !0 }), k = m("textarea-field-container", {
    disabled: s,
    "read-only": c,
    resize: !C
  });
  return /* @__PURE__ */ _("div", { className: u, children: [
    e && /* @__PURE__ */ _("label", { htmlFor: r, className: t["textarea-label"], children: [
      /* @__PURE__ */ a("span", { className: t["textarea-label-text"], children: e }),
      V && /* @__PURE__ */ a("sup", { children: "*" }),
      n && /* @__PURE__ */ a(
        w,
        {
          message: n,
          preference: y.LEFT,
          className: t["textarea-label-tooltip"]
        }
      )
    ] }),
    /* @__PURE__ */ a("div", { className: k, children: /* @__PURE__ */ a(
      "textarea",
      {
        id: r,
        ref: d,
        className: `${t["textarea-field"]} ${o}`,
        disabled: s,
        readOnly: c,
        ...l
      }
    ) }),
    f && /* @__PURE__ */ a(
      "span",
      {
        role: "presentation",
        "aria-label": "message",
        "aria-details": `${e} text-area`,
        className: t["textarea-message"],
        children: f
      }
    )
  ] });
};
g.displayName = "ClassicTextArea";
const fa = B(
  ({ mlpVersion: r = x.ONE, ...o }, e) => r === x.ONE ? /* @__PURE__ */ a(g, { ...o, forwardedRef: e }) : /* @__PURE__ */ a(R, { ...o, forwardedRef: e })
);
fa.displayName = "TextArea";
export {
  g as C,
  fa as T
};
//# sourceMappingURL=TextArea-4fe2f782.mjs.map
